import styled from 'styled-components';

const FeedViewContainer = styled.div`
  width: 100%;
`;

export {
  FeedViewContainer,
};
